module.exports = __webpack_public_path__ + "static/media/hand-shake.f06fc3e2.svg";